var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "h-full"
    },
    [
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showToast,
              expression: "showToast"
            }
          ],
          staticClass: "toast-box"
        },
        [
          _c("section", { staticClass: "toast-box-content" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.toastHtml) } })
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "navList", class: [_vm.navSatus ? "expand" : "fold"] },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.navSatus,
                  expression: "!navSatus"
                }
              ],
              on: {
                mouseout: function($event) {
                  _vm.imgSrcObj.expand.status = 0
                },
                mouseover: function($event) {
                  _vm.imgSrcObj.expand.status = 1
                },
                click: function($event) {
                  return _vm.changeNavStatus(1)
                }
              }
            },
            [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.imgSrcObj.expand.status == 0,
                    expression: "imgSrcObj.expand.status == 0"
                  }
                ],
                attrs: { src: _vm.images.expandImg }
              }),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.imgSrcObj.expand.status == 1,
                    expression: "imgSrcObj.expand.status == 1"
                  }
                ],
                attrs: { src: _vm.images.expandActiveImg }
              }),
              _vm._m(0)
            ]
          ),
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _c(
              "ul",
              [
                _c("li", { staticClass: "switchNavList" }, [
                  _c(
                    "a",
                    {
                      on: {
                        mouseout: function($event) {
                          _vm.imgSrcObj.fold.status = 0
                        },
                        mouseover: function($event) {
                          _vm.imgSrcObj.fold.status = 1
                        },
                        click: function($event) {
                          return _vm.changeNavStatus(0)
                        }
                      }
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.imgSrcObj.fold.status == 0,
                            expression: "imgSrcObj.fold.status == 0"
                          }
                        ],
                        attrs: { src: _vm.images.foldImg }
                      }),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.imgSrcObj.fold.status == 1,
                            expression: "imgSrcObj.fold.status == 1"
                          }
                        ],
                        attrs: { src: _vm.images.foldActiveImg }
                      })
                    ]
                  )
                ]),
                _vm._l(_vm.menu, function(item, index) {
                  return _c("li", { key: index, staticClass: "router" }, [
                    _vm.showMenu(item)
                      ? _c(
                          "a",
                          {
                            class: { active: _vm.currentPath == item.path },
                            on: {
                              click: function($event) {
                                return _vm.changeMenu(item)
                              }
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(item.title))])]
                        )
                      : _vm._e()
                  ])
                })
              ],
              2
            )
          ]),
          _c("div", { staticClass: "logo" }, [
            _c("img", { attrs: { src: _vm.images.logoImg } })
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mian", class: [_vm.navSatus ? "" : "fold"] },
        [_c("no-ssr", [_c("nuxt", { attrs: { "keep-alive": "" } })], 1)],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("展"),
      _c("br"),
      _vm._v("开"),
      _c("br"),
      _vm._v("侧"),
      _c("br"),
      _vm._v("边"),
      _c("br"),
      _vm._v("栏")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e2ef490", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2ef490","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/sidebar.vue
// module id = XTPu
// module chunks = 4